import axios from 'axios'
import * as auth from './auth.js'
import * as users from './users.js'
import * as api from './api.js'
import * as webinars from './webinars.js'
import * as subscriptions from './subscriptions.js'
import * as quiz from './quiz.js';
import * as suggestions from './suggestions.js';
import * as requests from './requests.js';
import * as mixed from './mixed.js';
import * as sponsors from './sponsors.js';
import * as partners from './partners.js';
import * as landing from './landing.js';
import * as disciplines from './disciplines';
import * as stats from './stats';
import * as calendar from './calendar';
import * as superhosts from './superhosts'
import * as studygroups from './studygroups'
import * as zoom from './zoom.js';
import * as clientUrls from './clientUrls.js';
import constants from 'constants';

const {
  SHOW_MODAL,
  HIDE_MODAL
} = constants;

const showModal = (modalType, modalContentProps = {}) => ({
  type: SHOW_MODAL,
  modalType,
  modalContentProps
});

const hideModal = () => ({
  type: HIDE_MODAL
});

const actions = {
  showModal,
  hideModal
}

const globalActions = {
  ...auth,
  ...users,
  ...api,
  ...webinars,
  ...subscriptions,
  ...actions,
  ...quiz,
  ...suggestions,
  ...requests,
  ...mixed,
  ...sponsors,
  ...partners,
  ...landing,
  ...disciplines,
  ...stats,
  ...calendar,
  ...superhosts,
  ...studygroups,
  ...zoom,
  ...clientUrls,
}
export default globalActions;



// WEBPACK FOOTER //
// ./src/actions/index.js